var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachFileWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10L19.5 18M23.5 14L15.5 14",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28571 10.8571H13.2C12.96 11.3943 12.7771 11.9657 12.6743 12.5714H6.28571C2.81143 12.5714 0 9.76 0 6.28571C0 2.81143 2.81143 0 6.28571 0H18.2857C20.8114 0 22.8571 2.04571 22.8571 4.57143C22.8571 5.61143 22.5029 6.56 21.9086 7.32571C21.2914 7.08571 20.6286 6.93714 19.9429 6.89143C20.4368 6.54107 20.8063 6.04257 20.998 5.46814C21.1896 4.89371 21.1934 4.27318 21.0088 3.69644C20.8242 3.11971 20.4608 2.61672 19.9712 2.26034C19.4816 1.90397 18.8913 1.71271 18.2857 1.71429H6.28571C3.76 1.71429 1.71429 3.76 1.71429 6.28571C1.71429 8.81143 3.76 10.8571 6.28571 10.8571ZM8.57143 7.42857C7.94286 7.42857 7.42857 6.91429 7.42857 6.28571C7.42857 5.65714 7.94286 5.14286 8.57143 5.14286H16.381C16.8017 5.14286 17.1429 4.80174 17.1429 4.38095C17.1429 3.85497 16.7165 3.42857 16.1905 3.42857H8.57143C7.81367 3.42857 7.08694 3.72959 6.55112 4.26541C6.01531 4.80123 5.71429 5.52795 5.71429 6.28571C5.71429 7.04348 6.01531 7.7702 6.55112 8.30602C7.08694 8.84184 7.81367 9.14286 8.57143 9.14286H14.3314C14.9867 8.40705 15.7939 7.82217 16.6971 7.42857H8.57143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileWhiteIcon);
export default __webpack_public_path__ + "static/media/Attach_File_White_Icon.e6f25df1d638a82ec041c63cb95ade44.svg";
export { ForwardRef as ReactComponent };